import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/admin/chassis");

export const getIdPath = returnPath("/admin/chassis/:id");
